'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-BBBOZKTU.mjs";

// src/thunder/ThunderIcon.tsx
import { jsx } from "react/jsx-runtime";
var ThunderIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M15.5212 0.187988L14.1656 8.99931H21.1742L8.4788 23.8106L9.83439 14.9993H2.82578L15.5212 0.187988ZM7.17422 12.9993H12.1656L11.5212 17.188L16.8258 10.9993H11.8344L12.4788 6.81064L7.17422 12.9993Z",
          fill: "currentColor"
        }
      )
    })
  );
};

export {
  ThunderIcon
};
//# sourceMappingURL=chunk-74LH5QY4.mjs.map